// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Tekrarlı Ödeme Analizi',
  subtitle: 'Tekrarlı ödeme istatistikleri',
  totalPayments: 'Toplam Ödeme',
  activePayments: 'Aktif Ödemeler',
  monthlyRevenue: 'Aylık Gelir',
  yearlyRevenue: 'Yıllık Gelir',
  byFrequency: 'Sıklığa Göre',
  byType: 'Tipe Göre',
  byCompany: 'Şirkete Göre',
  noData: 'Veri bulunmuyor',
  fetchError: 'Veriler alınamadı',
  currency: 'Para Birimi',
  year: 'Yıl',
  monthSelection: 'Ay Seçimi',
  allMonths: 'Tüm Aylar',
  companyFilter: 'Firma Filtresi',
  allCompanies: 'Tüm Firmalar',
  packageType: 'Paket Tipi',
  allTypes: 'Tüm Tipler',
  includeServerCosts: 'Sunucu Maliyetlerini Dahil Et',
  monthlyAnalysis: 'Aylık Analiz',
  byCustomer: 'Müşteriye Göre',
  byPackageType: 'Paket Tipine Göre',
  selectedMonthDetail: 'Seçilen Ay Detayı',
  totalPurchase: 'Toplam Alış',
  totalSale: 'Toplam Satış',
  totalProfit: 'Toplam Kar',
  purchase: 'Alış',
  sale: 'Satış',
  profit: 'Kar',
  profitLoss: 'Kar/Zarar',
  paymentCount: 'Ödeme Sayısı',
  monthlyChart: 'Aylık Grafik',
  monthlyTable: 'Aylık Tablo',
  month: 'Ay',
  detailedPayments: 'Detaylı Ödemeler',
  goBack: 'Geri Dön',
  company: 'Şirket',
  package: 'Paket',
  type: 'Tip',
  frequency: 'Sıklık',
  domain: 'Domain',
  packageName: 'Paket Adı',
  packageTypeText: 'Paket Tipi',
  purchasePrice: 'Alış Fiyatı',
  purchaseCurrency: 'Alış Para Birimi',
  salePrice: 'Satış Fiyatı',
  saleCurrency: 'Satış Para Birimi',
  startDate: 'Başlangıç Tarihi',
  nextPayment: 'Sonraki Ödeme',
  paymentProbability: 'Ödeme İhtimali',
  monthlyPurchaseTRY: 'Aylık Alış (TL)',
  monthlySaleTRY: 'Aylık Satış (TL)',
  yearlyPurchaseTRY: 'Yıllık Alış (TL)',
  yearlySaleTRY: 'Yıllık Satış (TL)',
  noPaymentsForMonth: 'Bu ay için ödeme bulunmuyor',
  serverCosts: 'Sunucu Maliyetleri',
  server: 'Sunucu',
  unknownCompany: 'Bilinmeyen Şirket',
  unknownCustomer: 'Bilinmeyen Müşteri',
  unassignedCustomer: 'Atanmamış',
  byCompanyAnalysis: 'Şirkete Göre Analiz',
  byCustomerAnalysis: 'Müşteriye Göre Analiz',
  byPackageTypeAnalysis: 'Paket Tipine Göre Analiz',
  customer: 'Müşteri'
};
